import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign DOM errors from Radix UI portal components
const origError = window.addEventListener;
window.addEventListener = function (type, handler, ...args) {
  if (type === "error") {
    const wrapped = function (event) {
      const msg = event.message || "";
      if (
        msg.includes("ResizeObserver loop") ||
        msg.includes("removeChild") ||
        msg.includes("insertBefore") ||
        msg.includes("removeChildFromContainer")
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return;
      }
      return handler(event);
    };
    return origError.call(this, type, wrapped, ...args);
  }
  return origError.call(this, type, handler, ...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
